import {
  BundleSliderWrapper,
  BundlesPickPlan,
  BundlesPlanWrapper,
  BundlesSelectVisitsText,
  BundlesStepContent,
  BundlesStepNumber,
  BundlesStepTitle,
  BundlesStepTitleBold,
  BundlesStepTitleWrapper,
  BundlesStepWrapper,
  BundlesUpToWrapper,
} from 'Features/pricing/tabs/Bundles/Bundle.styled'
import { isMobile } from 'react-device-detect'
import { Trans, useTranslation } from 'react-i18next'
import { Slider, useFrontEndEventTrackingService } from '@clickcease/cc-client-components-lib'
import { BundlePlanMobileWrapper } from 'Features/pricing/components/BundlePlanMobileWrapper/BundlePlanMobileWrapper'
import paidMarketingPlansJson from 'Features/pricing/tabs/PaidMarketing/paidMarketingPlans.json'
import { PRODUCT_TYPES } from 'Types/ProductTypes'
import { PricingPlansDesktop } from 'Features/pricing/components/PricingPlansDesktop/PricingPlansDesktop'
import { PlanBoxFeatures } from 'Features/pricing/components/PlanBox/PlanBoxFeatures'
import botMitigationPlansJson from 'Features/pricing/tabs/BotMitigation/botMitigationPlans.json'
import React, { useState } from 'react'
import { CurrenciesTypes } from 'Types/Currencies'
import { Plan } from 'Features/pricing/types/Plan'
import { PlanTypes } from 'Types/PlansTypes'
import { PlanBoxSeparator } from 'Features/pricing/components/PlanBox/PlanBox.styled'
import { EnterprisePlan } from 'Features/pricing/components/PlanBox/EnterprisePlan'
import { CePlans } from 'Features/pricing/components/PlanBox/CePlans'
import { botMitigationPlanSizes, paidMarketingPlanSizes } from 'Features/pricing/models/planSizes'
import { UpToVisits } from 'Features/pricing/components/UpToVisits/UpToVisits'
import { ScheduleCallModal } from 'Features/ScheduleCallModal/ScheduleCallModal'

type BundleStepsProps = {
  currency: CurrenciesTypes
  paidMarketingPlansDb: Array<Plan>
  botMitigationPlansDb: Array<Plan>
  pmNumOfVisits: number
  pmSelectedPlan: PlanTypes
  setPmNumOfVisits: (value: number) => void
  setPmSelectedPlan: (plan: PlanTypes) => void
  bmNumOfVisits: number
  bmSelectedPlan: PlanTypes
  setBmNumOfVisits: (value: number) => void
  setBmSelectedPlan: (plan: PlanTypes) => void
}

export const BundleSteps = ({
  currency,
  paidMarketingPlansDb,
  botMitigationPlansDb,
  pmNumOfVisits,
  pmSelectedPlan,
  setPmSelectedPlan,
  setPmNumOfVisits,
  bmNumOfVisits,
  bmSelectedPlan,
  setBmNumOfVisits,
  setBmSelectedPlan,
}: BundleStepsProps) => {
  const { t } = useTranslation('pricing')
  const { track } = useFrontEndEventTrackingService()
  const [modalToShow, setModalToShow] = useState<boolean>(false)

  const handleClick = () => {
    setModalToShow(true)
    track(['dataLayer'], 'schedule a call', {})
  }
  return (
    <>
      <BundlesStepWrapper>
        <BundlesStepContent>
          <BundlesStepTitleWrapper>
            <BundlesStepTitle>
              {isMobile ? (
                <BundlesStepNumber>{t('bundles.step_1')}</BundlesStepNumber>
              ) : (
                <Trans ns="pricing" i18nKey="bundles.step1_title">
                  - Pick your Paid Marketing plan
                  <BundlesStepTitleBold>Step 1</BundlesStepTitleBold>
                </Trans>
              )}
            </BundlesStepTitle>
          </BundlesStepTitleWrapper>
          <BundlesUpToWrapper>
            {isMobile ? (
              <BundlesSelectVisitsText>{t('bundles.select_pm_plan')}</BundlesSelectVisitsText>
            ) : (
              <UpToVisits numOfVisits={pmNumOfVisits} maxVisits={1000} />
            )}
          </BundlesUpToWrapper>
          <BundleSliderWrapper>
            <Slider
              width={isMobile ? '90%' : '588px'}
              isMobile={isMobile}
              min={100}
              max={1250}
              previousValue={pmNumOfVisits}
              value={pmNumOfVisits}
              steps={paidMarketingPlanSizes}
              minUnit={'k'}
              maxUnit={t('bundles.million')}
              maxText={t('bundles.million_number', { number: 1 })}
              onChange={(value) => setPmNumOfVisits(value as number)}
            />
          </BundleSliderWrapper>
          {isMobile && <BundlesPickPlan>{t('bundles.pick_paid_marketing_plan')}</BundlesPickPlan>}
          <BundlesPlanWrapper>
            {isMobile ? (
              <BundlePlanMobileWrapper
                numOfVisits={pmNumOfVisits}
                selectedPlan={pmSelectedPlan}
                setSelectedPlan={(plan) => (plan ? setPmSelectedPlan(plan) : null)}
                plansDb={paidMarketingPlansDb}
                plansJson={paidMarketingPlansJson}
                productName={PRODUCT_TYPES.PAID_MARKETING}
                currency={currency}
              />
            ) : (
              <PricingPlansDesktop
                numOfVisits={pmNumOfVisits}
                selectedPlan={pmSelectedPlan}
                setSelectedPlan={(plan) => (plan ? setPmSelectedPlan(plan) : null)}
                plansDb={paidMarketingPlansDb}
                plansJson={paidMarketingPlansJson}
                productName={PRODUCT_TYPES.PAID_MARKETING}
                bundle={true}
                currency={currency}
              />
            )}
            {isMobile && (
              <>
                {pmSelectedPlan === 'Enterprise' ? (
                  <EnterprisePlan hideCustomPricingTitle={true} handleClick={handleClick} />
                ) : (
                  <CePlans
                    hidePrice={true}
                    numOfVisits={pmNumOfVisits}
                    planName={pmSelectedPlan}
                    bundle={true}
                    plansJson={paidMarketingPlansJson}
                    plansDb={paidMarketingPlansDb}
                    product={PRODUCT_TYPES.PAID_MARKETING}
                    currency={currency}
                  />
                )}
                <PlanBoxSeparator />
                <PlanBoxFeatures plansJson={paidMarketingPlansJson} planName={pmSelectedPlan} />
              </>
            )}
          </BundlesPlanWrapper>
        </BundlesStepContent>
        {/*---------bot mitigation starts here---------*/}
        <BundlesStepContent>
          <BundlesStepTitle>
            {isMobile ? (
              <BundlesStepNumber>{t('bundles.step_2')}</BundlesStepNumber>
            ) : (
              <Trans ns="pricing" i18nKey="bundles.step2_title">
                - Pick your Bot Mitigation plan
                <BundlesStepTitleBold>Step 2</BundlesStepTitleBold>
              </Trans>
            )}
          </BundlesStepTitle>
          <BundlesUpToWrapper>
            {isMobile ? (
              <BundlesSelectVisitsText>{t('bundles.select_pm_plan')}</BundlesSelectVisitsText>
            ) : (
              <UpToVisits numOfVisits={bmNumOfVisits} maxVisits={1500} />
            )}
          </BundlesUpToWrapper>
          <BundleSliderWrapper>
            <Slider
              width={isMobile ? '90%' : '588px'}
              isMobile={isMobile}
              min={200}
              max={1750}
              value={bmNumOfVisits || 200}
              previousValue={bmNumOfVisits}
              steps={botMitigationPlanSizes}
              minUnit={'k'}
              maxUnit={t('bundles.million')}
              maxText={t('bundles.million_number', { number: 1.5 })}
              onChange={(value) => setBmNumOfVisits(value as number)}
            />
          </BundleSliderWrapper>
          {isMobile && <BundlesPickPlan>{t('bundles.pick_bot_mitigation_plan')}</BundlesPickPlan>}
          <BundlesPlanWrapper>
            <BundlesPlanWrapper>
              {isMobile ? (
                <BundlePlanMobileWrapper
                  numOfVisits={bmNumOfVisits}
                  selectedPlan={bmSelectedPlan}
                  setSelectedPlan={(plan) => (plan ? setBmSelectedPlan(plan) : null)}
                  plansDb={botMitigationPlansDb}
                  plansJson={botMitigationPlansJson}
                  productName={PRODUCT_TYPES.BOT_ZAPPING}
                  currency={currency}
                />
              ) : (
                <PricingPlansDesktop
                  numOfVisits={bmNumOfVisits}
                  plansDb={botMitigationPlansDb}
                  plansJson={botMitigationPlansJson}
                  productName={PRODUCT_TYPES.BOT_ZAPPING}
                  bundle={true}
                  currency={currency}
                  selectedPlan={bmSelectedPlan}
                  setSelectedPlan={(plan) => (plan ? setBmSelectedPlan(plan) : null)}
                />
              )}
              {isMobile && (
                <>
                  {bmSelectedPlan === 'Enterprise' ? (
                    <EnterprisePlan hideCustomPricingTitle={true} handleClick={handleClick} />
                  ) : (
                    <CePlans
                      hidePrice={true}
                      numOfVisits={bmNumOfVisits}
                      planName={bmSelectedPlan}
                      plansJson={botMitigationPlansJson}
                      plansDb={botMitigationPlansDb}
                      bundle={true}
                      product={PRODUCT_TYPES.BOT_ZAPPING}
                      currency={currency}
                    />
                  )}
                  <PlanBoxSeparator />
                  <PlanBoxFeatures plansJson={botMitigationPlansJson} planName={bmSelectedPlan} />
                </>
              )}
            </BundlesPlanWrapper>
          </BundlesPlanWrapper>
        </BundlesStepContent>
      </BundlesStepWrapper>
      <ScheduleCallModal onOpenChange={() => setModalToShow(false)} isOpen={modalToShow} />
    </>
  )
}
